import {
  beAccountSettingsGetUserSetting,
  beAccountSettingsPostUserSettings
} from 'Api/beAccountSettingsApi'
import { beEmailCheckupFastMessageCheck } from 'Api/beEmailCheckupApi'
import { BeListApiGetList } from 'Api/BeListApi'
import { beMessGetMessageDetails } from 'Api/BeMessApi'
import { bePecPlusGetPecPlusConfig } from 'Api/bePecPlusApi'
import { beRecipientGetListOfGroupDetails } from 'Api/beRecipientApi'
import { beSendGoSendToGroup, beSendGoSendToRecipients } from 'Api/beSendGoApi'
import { storeGet } from 'Helpers/localStorage'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE
} from 'mailup-react-helpers'
import { MAX_EMAIL } from '../state/state'

import { LOGIN_TYPE_WEBLOGIN } from 'Constants/'

export async function getPecPlusConfigStatus() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const pecPlus = await bePecPlusGetPecPlusConfig(idList)

  return pecPlus ? pecPlus.Status : undefined
}

export async function checkMessageErrors(idMessage) {
  const checks = {
    Checks: [
      'Size',
      'Attachments',
      'DynamicContents',
      'LiquidCode',
      'Links',
      'Content'
    ]
  }

  const {
    CheckLiquidCode,
    CheckAttachments,
    CheckDynamicContents,
    CheckSize,
    CheckBlacklistResult,
    CheckContent
  } = await beEmailCheckupFastMessageCheck(idMessage, checks)

  return (
    !CheckLiquidCode ||
    !CheckAttachments.Check ||
    !CheckDynamicContents.Check ||
    !CheckSize.Check ||
    CheckBlacklistResult.Action === 2 ||
    CheckContent.Action === 2
  )
}

export async function getMessageDetails(idMessage) {
  const result = beMessGetMessageDetails(idMessage)

  return result
}

export async function getAccountEmails() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beAccountSettingsGetUserSetting(
    idList,
    'QuickSend-EmailAddresses'
  )
  return result
}

export async function getListDetails() {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const result = BeListApiGetList(idList)

  return result
}

export async function saveEmailAddresses(dataValue) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)

  if (loginType === LOGIN_TYPE_WEBLOGIN) {
    beAccountSettingsPostUserSettings(
      idList,
      'QuickSend-EmailAddresses',
      dataValue
    )
  }
}

export async function sendToRecipients(idMessage, data) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const result = beSendGoSendToRecipients(idMessage, idList, data)

  return result
}

export async function sendToGroup(idMessage, idGroup, data) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const result = beSendGoSendToGroup(idMessage, idList, idGroup, data)

  return result
}

export async function getGroups() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const { Items: groups } = await beRecipientGetListOfGroupDetails(idList, {})

  return groups.map(t => ({
    label: `${t.Id} - ${t.Name}`,
    value: t.Id
  }))
}

export async function getSmallGroups() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const { Items: smallGroups } = await beRecipientGetListOfGroupDetails(
    idList,
    {
      orderBy: 'Id',
      orderDescending: true,
      countMaxLimit: MAX_EMAIL,
      subscriberStatus: 'SUBSCRIBED',
      hasRecipients: 'HASEMAILRECIPIENTS'
    }
  )

  return smallGroups.map(t => ({
    label: `${t.Id} - ${t.Name}`,
    value: t.Id
  }))
}
